/**
 * The direction options for flipper.
 * @public
 */
export const FlipperDirection = {
    next: "next",
    previous: "previous",
};
